/**
 * <PageBody/> — shared scroll-container + centered inner.
 *
 * Sits inside `<PageShell/>` `pageBody` slot and provides the consistent
 * 20/24/40 padding + 1200px centered inner that both Workflows and
 * Marketplace pages need.
 *
 * Pass `centered={false}` to skip the max-width inner (e.g. for surfaces
 * that fill the full pane).
 */
import clsx from 'clsx';
import type { ReactElement, ReactNode } from 'react';

import * as styles from './page-body.css';
import { usePageChromeCollapse } from './page-shell';

interface PageBodyProps {
  children: ReactNode;
  /** Center to 1200px max-width (default `true`). */
  centered?: boolean;
  className?: string;
}

export function PageBody({
  children,
  centered = true,
  className,
}: PageBodyProps): ReactElement {
  const chromeCollapse = usePageChromeCollapse();

  return (
    <div
      className={clsx(styles.pageBodyScroll, className)}
      onScroll={chromeCollapse?.onBodyScroll}
    >
      {centered ? (
        <div className={styles.pageBodyInner}>{children}</div>
      ) : (
        children
      )}
    </div>
  );
}
